/**
 * Fired on window when the console refuses to connect an integration because
 * the license's integration limit is reached (403 LICENSE_INTEGRATION_LIMIT_EXCEEDED).
 * Its own module so the shell's notice does not depend on the API client.
 */
export const INTEGRATION_LIMIT_EVENT = 'ops:integration-limit-reached'
